import {CloseCommand} from "slotworks/commands/comms/close-command";
import Components from "slotworks/components/components";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import AutoplayModel from "slotworks/model/autoplay-model";
import State from "slotworks/state-machine/states/state";
import {showPFSIntro} from "../../../commands/promo-free-spins/show-pfs-intro";

export default class GameOver extends State {
    public onEnter() {
        const betMenuMediator = new BetMenuMediator();
        betMenuMediator.start().execute();
        betMenuMediator.end();

        Components.footer.showNoWin();

        if (CampaignsModel.isFreespinsActive() && !AutoplayModel.isAutoPlaying()) {
            Components.promoBetBar.setEnabled(true);
            showPFSIntro();
        }

        CloseCommand().then(() => this.complete());
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/game-over.ts